<template>
  <v-list subheader>
    <v-subheader>Department</v-subheader>

    
    <v-list-item @click="openReport('all')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/money.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Pending Balance By Departments</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    
  </v-list>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),
    openReport(link) {
      let routeData = this.$router.resolve({
        path: `/reportView/department/${link}`,
      });
      window.open(routeData.href, "_blank");
    },
    openDateSelector(val) {
      this.setReportName(val);
      this.setDateSelector(true);      
    },
  },
};
</script>

<style scoped></style>
